import type React from "react"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap"
import * as echarts from "echarts";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useAzureData } from "../../context/AzureContext";
import './RagCost.css';
import { RagCostAnalysisGraph, getEnvironments, getServiceNames, getServingCost, getVectorSearchIndex } from "../../service/ragApiServices";
import { format } from 'date-fns-tz';

function formatDateToWestEurope(date: any) {
    // return new Date(date).toISOString();
    return format(date, "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone: "UTC" });
}

// @ts-ignore
const RagCost: React.FC = ({ showLegend, showPercentYaxis, onFiltersChange, setFetchedOtherRagCost }) => {
    const chartRef = useRef<HTMLDivElement>(null)
    const { graphData, apiToken } = useAzureData();
    const [serviceNames, setServiceNames] = useState<any>([]);
    const [vectorSearchNames, setVectorSearchNames] = useState<any>([]);
    const [selectedServiceNames, setSelectedServiceNames] = useState<any>([]);
    const [selectedVectorSearchNames, setSelectedVectorSearchNames] = useState<any>([]);
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const [chartData, setChartData] = useState<any>(null);
    const [loading, setLoading] = useState<any>(false);
    const [OtherCostloading, setOtherCostLoading] = useState<any>(false);
    const loggedInUser = graphData?.['mail'] ?? "";
    const [environments, setEnvironments] = useState<any>([]);
    const [selectedEnvironment, setSelectedEnvironment] = useState<any>(null);
    const [otherCost, setOtherCost] = useState<any>(0);
    const [errorMessage, setErrorMessage] = useState<any>(null);
    const [totalIngestionCost, setTotalIngestionCost] = useState<any>(0);

    const fetchServiceNames = async () => {
        try {
            const response = await getServiceNames(apiToken, loggedInUser);
            // @ts-ignore
            setServiceNames(response?.data?.data ?? []);
        } catch (error) {
            console.error("Error fetching service names:", error);
        }
    };

    useEffect(() => {
        fetchServiceNames();
    }, [loggedInUser]);

    // Fetch vector search names
    useEffect(() => {
        const fetchVectorSearchNames = async () => {
            if (!selectedServiceNames.length) {
                setVectorSearchNames([]);
                setSelectedVectorSearchNames([]); // Clear selection when no service is selected
                return;
            }

            try {
                const input = {
                    servicenames: selectedServiceNames?.map((item: any) => item.value),
                    created_by: loggedInUser,
                }
                const response = await getVectorSearchIndex(apiToken, input);

                // @ts-ignore
                const fetchedVectorSearchNames = response?.data?.data?.map((name: any) => ({
                    value: name,
                    label: name,
                }));

                setVectorSearchNames(fetchedVectorSearchNames);

                // Prepopulate vector search dropdown
                setSelectedVectorSearchNames(fetchedVectorSearchNames);
            } catch (error) {
                console.error("Error fetching vector search names:", error);
                alert(
                    "Failed to load vector search index names. Please try again later."
                );
            }
        };

        fetchVectorSearchNames();
    }, [selectedServiceNames, loggedInUser]);

    // fetch environments
    useEffect(() => {
        const fetchEnvironments = async () => {
            try {
                const response = await getEnvironments(apiToken)
                // @ts-ignore
                const fetchedEnvironments = response?.data?.data?.map((env: any) => ({
                    value: env,
                    label: env,
                }));
                setEnvironments(fetchedEnvironments);
            } catch (error) {
                console.error("Error fetching environments:", error);
                alert("Failed to load environments. Please try again later.");
            }
        };
        fetchEnvironments();
    }, []);

    const fetchOtherCost = async () => {
        setOtherCostLoading(true)
        setFetchedOtherRagCost(false);
        try {
            const input = {
                created_by: loggedInUser,
                servicenames: selectedServiceNames.map((item: any) => item.value),
                vector_search_index_names: selectedVectorSearchNames.map((item: any) => item.value),
                environment: selectedEnvironment?.value,
                start_date: formatDateToWestEurope(startDate),
                end_date: formatDateToWestEurope(endDate),
            }

            const response = await getServingCost(apiToken, input)
            // @ts-ignore
            setOtherCost(response?.data?.data?.serving_cost || 0);
            setFetchedOtherRagCost(true);
            setOtherCostLoading(false)
        } catch (error) {
            console.error("Error fetching other cost:", error);
            setOtherCostLoading(false)
            setFetchedOtherRagCost(false);
        }
    };

    // const handleSubmit = async (e: any) => {
    //     e.preventDefault();

    //     if (
    //         !selectedServiceNames.length ||
    //         !selectedVectorSearchNames.length ||
    //         !startDate ||
    //         !endDate ||
    //         !selectedEnvironment
    //     ) {
    //         alert("All fields are required!");
    //         return;
    //     }

    //     try {
    //         setLoading(true);

    //         const input = {
    //             created_by: loggedInUser,
    //             servicenames: selectedServiceNames.map((item: any) => item.value),
    //             vector_search_index_names: selectedVectorSearchNames.map((item: any) => item.value),
    //             start_date: formatDateToWestEurope(startDate),
    //             end_date: formatDateToWestEurope(endDate),
    //             environment: selectedEnvironment.value,
    //         };

    //         const response: any = await RagCostAnalysisGraph(apiToken, input);
    //         const data = response?.data?.data;

    //         if (!data || data.length === 0) {
    //             setErrorMessage("No data found for the selected criteria.");
    //             setChartData(null);
    //             return;
    //         }

    //         // mapping
    //         const xAxisCategories = data.map((item: any) => {
    //             const date = new Date(item.usage_date);
    //             return `${date.getFullYear()}-${date.toLocaleString("en-US", {
    //                 month: "short",
    //             })}-${String(date.getDate()).padStart(2, "0")}`;
    //         });

    //         const seriesData = data.map((item: any) =>
    //             Number(item.ingestion_cost)
    //         );

    //         setChartData({
    //             xAxis: {
    //                 categories: xAxisCategories,
    //             },
    //             series: {
    //                 name: "Ingestion Cost (USD)",
    //                 data: seriesData,
    //             },
    //         });

    //         const totalIngestionCost = seriesData?.reduce((acc: number, val: number) => acc + val, 0);
    //         setTotalIngestionCost(totalIngestionCost);

    //         // const other_cost = values.reduce((sum, value) => sum + value, 0);
    //         // setOtherCost(other_cost);

    //         fetchOtherCost();
    //         setErrorMessage(null);

    //     } catch (error) {
    //         console.error("Error fetching analysis data:", error);

    //         setErrorMessage("No data found for the selected criteria.");
    //         setChartData(null);
    //         setTotalIngestionCost(0);
    //         setOtherCost(0);

    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (
            !selectedServiceNames.length ||
            !selectedVectorSearchNames.length ||
            !startDate ||
            !endDate ||
            !selectedEnvironment
        ) {
            alert("All fields are required!");
            return;
        }

        // SEND DATA TO PARENT
        onFiltersChange({
            selectedServiceNames,
            selectedVectorSearchNames,
            startDate,
            endDate,
            selectedEnvironment,
        });

        try {
            setLoading(true);
            setOtherCost(0)
            const input = {
                created_by: loggedInUser,
                servicenames: selectedServiceNames.map((item: any) => item.value),
                vector_search_index_names: selectedVectorSearchNames.map((item: any) => item.value),
                start_date: formatDateToWestEurope(startDate),
                end_date: formatDateToWestEurope(endDate),
                environment: selectedEnvironment.value,
            };

            const response: any = await RagCostAnalysisGraph(apiToken, input);
            const data = response?.data?.data;

            if (!data || data.length === 0) {
                setErrorMessage("No data found for the selected criteria.");
                setChartData(null);
                setTotalIngestionCost(0);
                return;
            }

            // ---------------------------
            // GROUPING LOGIC
            // ---------------------------
            const start = new Date(startDate);
            const end = new Date(endDate);

            const diffDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;

            let grouping: "daily" | "weekly" | "monthly" | "yearly" = "daily";

            if (diffDays <= 7) grouping = "daily";
            else if (diffDays <= 31) grouping = "weekly";
            else if (diffDays <= 365) grouping = "monthly";
            else grouping = "yearly";

            const formatDay = (date: Date) =>
                date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

            const formatMonth = (date: Date) =>
                date.toLocaleDateString("en-GB", { month: "short", year: "numeric" });

            const formatYear = (date: Date) => date.getFullYear().toString();

            const bucketMap: Record<string, number> = {};

            data.forEach((item: any) => {
                const d = new Date(item.usage_date);
                let key = "";

                if (grouping === "daily") {
                    key = formatDay(d);
                }

                else if (grouping === "weekly") {
                    const diffFromStart = Math.floor(
                        (d.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
                    );
                    const weekIndex = Math.floor(diffFromStart / 7);

                    const weekStart = new Date(start);
                    weekStart.setDate(start.getDate() + weekIndex * 7);

                    const weekEnd = new Date(weekStart);
                    weekEnd.setDate(weekStart.getDate() + 6);

                    key = `${formatDay(weekStart)} - ${formatDay(weekEnd)}`;
                }

                else if (grouping === "monthly") {
                    key = formatMonth(d);
                }

                else if (grouping === "yearly") {
                    key = formatYear(d);
                }

                bucketMap[key] = (bucketMap[key] || 0) + Number(item.ingestion_cost);
            });

            const xAxisCategories = Object.keys(bucketMap);
            const seriesData = Object.values(bucketMap);

            setChartData({
                xAxis: {
                    categories: xAxisCategories,
                },
                series: {
                    name: `Ingestion Cost (${grouping})`,
                    data: seriesData,
                },
            });

            const totalIngestionCost = seriesData.reduce(
                (acc: number, val: number) => acc + val,
                0
            );
            setTotalIngestionCost(totalIngestionCost);

            fetchOtherCost();
            setErrorMessage(null);

        } catch (error) {
            console.error("Error fetching analysis data:", error);

            setErrorMessage("No data found for the selected criteria.");
            setChartData(null);
            setTotalIngestionCost(0);
            setOtherCost(0);

        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (!chartRef.current) return

        const chart = echarts.init(chartRef.current)

        const option = {
            title: {
                text: chartData?.title,
                textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    color: "#18181B",
                    lineHeight: 16
                },
                left: 0,
                top: 0,
                subtext: chartData?.subtitle,
                subtextStyle: {
                    fontSize: 14,
                    color: "#838FB4",
                    fontWeight: 400,
                    lineHeight: 16
                }
            },
            tooltip: {
                trigger: "axis",
            },
            grid: {
                left: "4%",
                right: "4%",
                bottom: "15%",
                top: "2%",
                // containLabel: true,
            },
            xAxis: {
                type: "category",
                data: chartData?.xAxis?.categories,
                name: "Usage Data",
                nameLocation: "middle",
                nameGap: 30,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400,
                    rotate: 45,
                    formatter: function (value: string) {
                        const maxLength = 10;
                        return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                    }
                },
            },
            yAxis: {
                type: "value",
                name: "Ingestion Cost(USD)",
                nameLocation: "middle",
                // nameGap: 65,
                nameRotate: 90,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    // formatter: showPercentYaxis ? "{value}%" : "{value}",
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400,
                    formatter: showPercentYaxis ? "{value}%" : function (value: any) {
                        if (value >= 1000000000000) return (value / 1000000000000) + 'T';
                        if (value >= 1000000000) return (value / 1000000000) + 'B';
                        if (value >= 1000000) return (value / 1000000) + 'M';
                        if (value >= 1000) return (value / 1000) + 'K';
                        return value;
                    }
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: "rgba(0, 102, 204, 0.25)"
                    }
                },
            },
            series: [
                {
                    name: chartData?.series?.name,
                    type: "line",
                    symbol: "circle",
                    symbolSize: 8,
                    data: chartData?.series?.data,
                    itemStyle: {
                        color: "#0066CC",
                    },
                },
            ],
        }

        chart.setOption(option)

        const handleResize = () => {
            chart.resize()
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
            chart.dispose()
        }
        //eslint-disable-next-line
    }, [chartData])

    const CheckboxOption = (props: any) => {
        const { data, isSelected, innerRef, innerProps } = props;

        return (
            <div
                ref={innerRef}
                {...innerProps}
                style={{ display: "flex", alignItems: "center", padding: "5px" }}
            >
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => null}
                    style={{ marginRight: "10px" }}
                />
                <label style={{ margin: 0 }}>{data.label}</label>
            </div>
        );
    };

    const handleSelectedServiceNames = (selected: any) => {
        // Check if "Select All" is selected
        const isSelectAllSelected = selected.some((item: any) => item.value === "select_all");
        const allServiceNames = serviceNames.map((name: any) => ({
            value: name,
            label: name,
        }));

        if (isSelectAllSelected) {
            // If "Select All" is selected and it is not already in the list, select all services
            if (selectedServiceNames.length === serviceNames.length) {
                setSelectedServiceNames([]);
            } else {
                setSelectedServiceNames(allServiceNames); // Select all services
            }
        } else {
            const filteredSelection = selected.filter((item: any) => item.value !== "select_all");

            // Add "Select All" if all services are selected
            if (filteredSelection.length === serviceNames.length) {
                setSelectedServiceNames([
                    { value: "select_all", label: "Select All" },
                    ...filteredSelection,
                ]);
            } else {
                setSelectedServiceNames(filteredSelection);
            }
        }
    };

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            minHeight: "44px", // Set a fixed height for the field
            overflow: "hidden",
        }),
        multiValueContainer: (provided: any) => ({
            ...provided,
            overflow: "auto", // Make selected values scrollable
        }),
        valueContainer: (provided: any) => ({
            ...provided,
            maxHeight: "70px", // Limit height of selected value container
            overflowY: "auto", // Add vertical scrolling for selected values
        }),
    };

    return (
        <Card className="shadow-sm rag_cost_card mt-3 mb-3">
            <Card.Body>

                {/* FILTER ROW */}
                <Form onSubmit={handleSubmit}>
                    <Row className="align-items-end g-2">

                        <Col md={3}>
                            <Form.Label>Environment</Form.Label>
                            <Select
                                options={environments}
                                value={selectedEnvironment}
                                onChange={setSelectedEnvironment}
                                placeholder="Select Env"
                            />
                        </Col>

                        <Col md={3}>
                            <Form.Label>Service</Form.Label>
                            <Select
                                isMulti
                                options={[
                                    { value: "select_all", label: "Select All" },
                                    ...serviceNames?.map((name: any) => ({ value: name, label: name })),
                                ]}
                                value={selectedServiceNames}
                                onChange={handleSelectedServiceNames}
                                styles={customStyles}
                                components={{ Option: CheckboxOption }}
                            />
                        </Col>

                        <Col md={3}>
                            <Form.Label>Vector Index</Form.Label>
                            <Select
                                isMulti
                                options={vectorSearchNames}
                                value={selectedVectorSearchNames}
                                onChange={setSelectedVectorSearchNames}
                                styles={customStyles}
                                components={{ Option: CheckboxOption }}
                            />
                        </Col>

                        <Col md={1}>
                            <Form.Label>Start</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={setStartDate}
                                className="form-control"
                            />
                        </Col>

                        <Col md={1}>
                            <Form.Label>End</Form.Label>
                            <DatePicker
                                selected={endDate}
                                onChange={setEndDate}
                                className="form-control"
                            />
                        </Col>

                        <Col md={1}>
                            <Button
                                type="submit"
                                className="unilever-btn-border1 w-100"
                            >
                                Submit
                            </Button>
                        </Col>

                    </Row>
                </Form>

                {/* CHART */}
                {loading ?
                    <div className="d-flex justify-content-center" style={{ marginTop: "10%" }}>
                        <Spinner animation="border" variant="primary" />
                    </div> :
                    <div className="mt-4" ref={chartRef} style={{ height: "420px" }} />
                }

                {/* FOOTER INFO */}
                {chartData && (
                    <Row className="mt-3 text-center">
                        <Col>
                            <div className="d-flex justify-content-center">
                                <span>Total Ingestion Cost: &nbsp;</span>
                                <h6>${totalIngestionCost.toFixed(2)}</h6>
                            </div>
                            <div className="d-flex justify-content-center">
                                <span>Serving Cost: &nbsp;</span>
                                {OtherCostloading ?
                                    <h6>Loading... &nbsp;</h6>:
                                    <h6> ${otherCost.toFixed(2)} &nbsp;</h6>
                                }
                                <span>(The cost is calculated proportionally based on actual usage)</span>
                            </div>
                        </Col>
                    </Row>
                )}

            </Card.Body>
        </Card>

    )
}

export default RagCost;